import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.admin.general');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-admin-general',
template: templateSource || '',
    styles: [`

/* file: /opt/season-cloud-manager/project/main/build/src/app/page.admin.general/view.scss */
/* src/app/page.admin.general/view.scss: no such file or directory */`],
})
export class PageAdminGeneralComponent implements OnInit {
    public updating: boolean = false;
    public settings: any = {};

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.auth.allow.role("admin", "/");
        await this.load();
        await this.service.render();
    }

    public async load() {
        const { code, data } = await wiz.call("load");
        if (code === 200) {
            this.settings = data || {};
        }
        // 기본값 설정
        if (!this.settings.api_endpoint_host) this.settings.api_endpoint_host = '';
    }

    public async update() {
        this.updating = true;
        await this.service.render();

        const data = {
            api_endpoint_host: this.settings.api_endpoint_host || ''
        };

        await wiz.call("update", { data: JSON.stringify(data) });
        await this.service.sleep(500);
        this.updating = false;
        await this.service.render();
    }
}

export default PageAdminGeneralComponent;